import { render, staticRenderFns } from "./StandardUserSidebar.vue?vue&type=template&id=009c6856&"
import script from "./StandardUserSidebar.vue?vue&type=script&lang=js&"
export * from "./StandardUserSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports